import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header"; // Ensure correct path
import Sidebar from "../components/Sidebar"; // Ensure correct path

export default function HomeLayout() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  return (
    <main className="page relative wrapper">
      {/* ✅ Navbar at the Top */}
      <Header isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed}/>
      {/* ✅ Main Content Below */}
      <div className="container-fluid container-xxl d-flex flex-row page relative wrapper">
        <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed}/>
        <div className="right-panel-component">
          <Outlet />
        </div>
      </div>
    </main>
  );
}
